import {styled} from '@mui/material';

const Container = styled('div')`
	width: 100%;
	padding: 32px;

	@media (max-width: 599px) {
		padding: 16px;
	}
`;

const ContentCards = styled('div')`
	grid-template-columns: repeat(4, 1fr);
	margin-top: 8px;
	display: grid;
	gap: 24px 16px;

	@media (max-width: 870px) {
		justify-content: center;
	}

	@media (max-width: 1723px) {
		grid-template-columns: repeat(3, 1fr);
	}

	@media (max-width: 1275px) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (max-width: 768px) {
		grid-template-columns: repeat(1, 1fr);
	}
`;

export {Container, ContentCards};
